import React, { useEffect, useState } from "react";
import zh_CN from "antd/es/locale/zh_CN";
import { message, Table, Space, Tooltip, ConfigProvider, Button } from "antd";
import copy from "copy-to-clipboard";
import "./History.scss";
import { DownloadOutlined } from "@ant-design/icons";
import SearchHead from "./components/SearchHead"; // 搜索区域
import BoxServe from "../../../ajax/api/index";
import { exportExcel } from "../../../utils/index";

export default function History(props) {
  const columns = [
    {
      title: "批次号",
      dataIndex: "batchNo",
      width: 200,
      fixed: "left",
    },
    {
      title: "设备号",

      dataIndex: "deviceNo",
      width: 200,
      fixed: "left",
    },
    {
      title: "执行命令",
      dataIndex: "command",
      width: 120,
      render: (_, record) => (
        <Space size="middle">
          <div className="result-content">
            <span className="text-content" style={{ maxWidth: "60px" }}>
              <Tooltip
                overlayStyle={{ maxWidth: "60%" }}
                title={record?.command}
                color={"blue"}
                key={"blue"}
              >
                <span>{record?.command}</span>
              </Tooltip>
            </span>
            <span
              className="text-copy"
              onClick={() => handleCopy("command", record?.command)}
            >
              {record?.command !== "" && String(record?.command) !== "null"
                ? "复制"
                : ""}
            </span>
          </div>
        </Space>
      ),
    },
    {
      title: "执行结果",

      dataIndex: "resultState",
      width: 90,
    },
    {
      title: "命令执行状态",

      dataIndex: "runState",
      width: 120,
      render: (_, record) => (
        <Space size="middle">
          <span>
            {record?.runState === 1
              ? "未执行"
              : record?.runState === null
              ? ""
              : "已执行"}
          </span>
        </Space>
      ),
    },
    {
      title: "命令执行返回内容",
      dataIndex: "resultContent",
      width: 250,
      render: (_, record) => (
        <Space size="middle">
          <div className="result-content">
            <span className="text-content" style={{ maxWidth: "200px" }}>
              <Tooltip
                overlayStyle={{ maxWidth: "90%" }}
                title={record?.resultContent}
                color={"blue"}
                key={"blue"}
              >
                <span>{record?.resultContent}</span>
              </Tooltip>
            </span>
            <span
              className="text-copy"
              onClick={(e) => handleCopy(e, record.resultContent)}
            >
              {record?.resultContent !== "" &&
              String(record?.resultContent) !== "null"
                ? "复制"
                : ""}
            </span>
          </div>
        </Space>
      ),
    },
    {
      title: "命令执行过程",

      dataIndex: "runStateName",
      width: 200,
      render: (_, record) => (
        <Space size="middle">
          <span>
            {record?.runStateName === 1 ? "未执行" : record?.runStateName}
          </span>
        </Space>
      ),
    },
    {
      title: "操作时间",

      dataIndex: "createTime",
      width: 160,
    },
  ];
  // 提示信息
  const [messageApi, contextHolder] = message.useMessage();
  const [searchParams, setSearchParams] = useState({});
  const [tableParams, setTableParams] = useState({
    page: 1,
    limit: 20,
    current: 1,
    defaultPageSize: 20,
  });
  const [loading, setLoading] = useState(false);

  let [list, setList] = useState([]);
  // 总条数
  const [total, setTotal] = useState(0);

  const [pagination, setPagination] = useState({
    page: tableParams.current,
    limit: 20,
  });

  // 搜索
  const handleSearch = (obj) => {
    setSearchParams(obj);
    setPagination({
      page: 1,
      limit: 20,
    });
    setTableParams({
      ...tableParams,
      ...obj,
      page: 1,
      current: 1,
    });
  };

  // 复制
  const handleCopy = (e, contents) => {
    if (copy(contents)) {
      messageApi.open({
        type: "success",
        content: "复制成功！",
      });
    } else {
      messageApi.open({
        type: "error",
        content: "复制失败！",
      });
    }
  };

  // 分页等
  const onChange = (pagination) => {
    const { current, pageSize } = pagination;
    setList([]);
    setPagination({
      page: current,
      limit: pageSize,
    });
    setTableParams({
      page: current,
      current: current,
    });
  };

  useEffect(() => {
    getTasklogList();
  }, [props, searchParams, pagination]);

  // 获取列表数据
  const getTasklogList = async () => {
    try {
      setLoading(true);
      const { code, data, count } = await BoxServe.getTasklogList({
        ...tableParams,
        ...searchParams,
        ...pagination,
      }).finally(() => {
        setLoading(false);
      });
      if (String(code) === "0") {
        setTableParams({
          ...tableParams,
          // total: count ? Number(count) : 0,
        });
        setTotal(count ? Number(count) : 0);
        const list = data?.map((item) => {
          return {
            ...item,
            key: item.id,
          };
        });
        setList(list);
      } else {
        messageApi.open({
          type: "warning",
          content: "出错了~",
        });
      }
    } catch (error) {
      // message.error(error.message || error.msg)
      console.log(error);
    }
  };

  const handleExportExcel = () => {
    const name = `box_历史记录列表_${new Date().getTime()}`;
    const sheetHeader = [];
    const sheetFilter = [];
    const columnWidths = [];

    // const sheetHeader = ["设备号", "状态", "设备所在地", "运行业务"];
    // let sheetFilter = ["deviceNo", "onlineState", "city", "askBusiness"];
    columns?.forEach((item) => {
      let { title, dataIndex, width } = item;
      if (title !== "操作") {
        sheetHeader.push(title);
      }
      sheetFilter.push(dataIndex);
      columnWidths.push(width / 10);
    });
    exportExcel(list, name, sheetHeader, sheetFilter, columnWidths);
  };

  // 重置
  const handleReset = () => {
    setTableParams({
      page: 1,
      limit: 20,
      current: 1,
      defaultPageSize: 20,
    });
    setPagination({
      page: 1,
      // current: 1,
      limit: 20,
    });
  };

  return (
    <>
      {contextHolder}
      <div className="history-wrap">
        <div className="search-wrap">
          <SearchHead handleSearch={handleSearch} handleReset={handleReset} />
        </div>
        <div className="top">
          <div className="top-left"></div>
          <div className="top-right">
            <Space wrap className="operate-btn">
              <Button
                type="dashed"
                danger
                icon={<DownloadOutlined />}
                onClick={handleExportExcel}
              >
                导出Excel
              </Button>
            </Space>
          </div>
        </div>
        <ConfigProvider locale={zh_CN}>
          <Table
            scroll={{ x: "100%" }}
            filterMultiple
            columns={columns}
            dataSource={list}
            loading={loading}
            pagination={{
              showSizeChanger: true,
              pageSizeOptions: [10, 20, 50, 100, 500, 1000, 5000, 10000],
              total,
              ...tableParams,
              showTotal: (total) => {
                return `共 ${total} 条`;
              },
            }}
            onChange={onChange}
          />
        </ConfigProvider>
      </div>
    </>
  );
}
